import { formatDate } from '@/utils/formatters';

const ChatsDateSeparator = ({ date }: { date: string }) => {
  return (
    <div className="text-center text-md text-lightGray md:flex md:items-center md:justify-center md:py-0.5 md:text-xs">
      <span className="md:rounded-full md:bg-white/80 md:px-3 md:py-1 md:font-medium md:shadow-xs">
        {formatDate(date, { dateStyle: 'long' })}
      </span>
    </div>
  );
};

export default ChatsDateSeparator;
